import { render, staticRenderFns } from "./EventRegistrationForm.vue?vue&type=template&id=62f1b84c&scoped=true&"
import script from "./EventRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./EventRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f1b84c",
  null
  
)

export default component.exports